/* the reference: open header dropdowns on HOVER (like the reference /
   Impulse) instead of Dawn's click-to-open. Desktop + hover devices
   only; mobile keeps the drawer. Integrates with Dawn's <details>
   (setting .open fires the 'toggle' event Dawn's HeaderMenu listens
   for, so overlay/aria handling stays intact). */
(function () {
  var mq = window.matchMedia('(min-width: 990px) and (hover: hover)');

  function bind(nav) {
    if (!nav || nav.__mbHoverBound) return;
    nav.__mbHoverBound = true;

    var items = nav.querySelectorAll('header-menu > details, li > details');
    items.forEach(function (details) {
      var li = details.closest('li') || details.parentElement;
      if (!li) return;
      var timer;

      function openThis() {
        clearTimeout(timer);
        items.forEach(function (d) {
          if (d !== details && d.open) { d.open = false; }
        });
        if (!details.open) { details.open = true; }
      }
      function closeSoon() {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (details.open) { details.open = false; }
        }, 140);
      }

      li.addEventListener('mouseenter', function () {
        if (mq.matches) openThis();
      });
      li.addEventListener('mouseleave', function () {
        if (mq.matches) closeSoon();
      });

      var sub = details.querySelector('.header__submenu');
      if (sub) {
        sub.addEventListener('mouseenter', function () { clearTimeout(timer); });
        sub.addEventListener('mouseleave', function () {
          if (mq.matches) closeSoon();
        });
      }
    });
  }

  function init() {
    document.querySelectorAll('.header__inline-menu').forEach(bind);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Re-bind when the header section reloads in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    var nav = e.target && e.target.querySelector
      ? e.target.querySelector('.header__inline-menu')
      : null;
    if (nav) { nav.__mbHoverBound = false; bind(nav); }
  });
})();
